import {
  ALTERNATIVEOFFERIDKEY,
  CONSUMER_CMS_SHOPPING_CART,
  getFormattedPriceString,
  getHubPath,
  getProductCategory,
  handleFirstCharacterOfSentence,
  ICarouselCMS,
  IGlobalConfigCMS,
  IGlobalPromoCMS,
  insertWidget,
  IRemappingTechnology,
  ITechs,
  IWidgetType,
  pushWidgets,
  START_FROM_APP_LOCKIN,
  START_FROM_LOCKIN,
  START_PRODUCT_HUB,
  useCmsConfig,
  usePage,
} from '@vfit/consumer/data-access';
import { API } from '@vfit/shared/data-access';
import { Fade } from 'react-awesome-reveal';
import { ImageDivider } from '@vfit/shared/atoms';
import { StickyOffer } from '@vfit/shared/components';
import { removeCurrency } from '@vfit/consumer/hooks';
import {
  Widgets,
  ProductDetail,
  ISupportModule,
  TopShoppingCartBanner,
} from '@vfit/consumer/components';
import { getLocalAddress, getTechLabels, getTechnology } from '../../shoppingCart.utils';
import { useCheckout } from '../../../iBuyFixed.context';
import { WidgetWrapper } from './shoppingCartContent.style';
import { isEnabledWaitingCart } from '../../../iBuyFixed.utils';
import { IShoppingCartContent } from './shoppingCartContent.models';
import { useQueryClient } from 'react-query';
import CartOfferProposal from '../CartOfferProposal/cartOfferProposal';
import { useState } from 'react';
import ConsumerTopShoppingCart from '../ConsumerTopShoppingCart/consumerTopShoppingCart';

const ShoppingCartContent = ({ isSuccessDynamicCart }: IShoppingCartContent) => {
  const queryClient = useQueryClient();
  const { product: pageProduct } = usePage();
  const { globalpromo } = (queryClient?.getQueryData('getGlobalPromo') || {}) as IGlobalPromoCMS;
  const { product, isShowCheckout, isLoadingCart, setIsShowCheckout } = useCheckout();
  const IS_LOADING_CART = isEnabledWaitingCart() ? isLoadingCart : !isSuccessDynamicCart;
  const startingHubTech = localStorage.getItem(START_PRODUCT_HUB);
  const hub = pageProduct ? getHubPath(pageProduct) || '' : getHubPath(product) || '';
  const allTechs = useCmsConfig(CONSUMER_CMS_SHOPPING_CART, API.CMS_GET_TECNOLOGIES) as ITechs;
  const supportModulesCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_SUPPORT_MODULE,
  ) as ISupportModule;
  const globalConfigCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GLOBAL_CONFIG,
  ) as IGlobalConfigCMS;
  const newRemappingTech = (queryClient?.getQueryData('getCmsTecnologies') || {})?.[
    'remappingtechnology'
  ] as IRemappingTechnology;
  const techLabels = getTechLabels(allTechs, newRemappingTech);
  const technology = getTechnology();
  const isAppLockInRetrieved = window.localStorage.getItem(START_FROM_APP_LOCKIN);
  const isAlternativeOffer = localStorage.getItem(ALTERNATIVEOFFERIDKEY);
  const isAppLockIn: boolean = !!isAppLockInRetrieved && JSON.parse(isAppLockInRetrieved as string);
  const startFromVodafoneFastwebHub = localStorage.getItem('FFTVH') === 'true';
  const [showFwBanner, setShowFwBanner] = useState(
    (product?.vffw?.showBanner &&
      globalConfigCms?.globalconfig?.banner?.showBanner === 'true' &&
      startFromVodafoneFastwebHub) ||
      false,
  );
  const [stickyOfferHeight, setStickyOfferHeight] = useState(0);
  const technologyInfo =
    allTechs?.[technology?.mappedCategory]?.technology ??
    allTechs?.[technology?.mappedCategory?.toLowerCase()]?.technology;

  const getWidgets = (): ICarouselCMS[] => {
    const {
      offerLockInWeb: lockInWeb,
      offerLockInApp: lockInApp,
      checkout,
      isLockInMMProduct,
      isLockInProduct,
    } = product;
    const startFromLockin = localStorage.getItem(START_FROM_LOCKIN);
    const { lockInHub, lockInMM } = lockInWeb || {};
    if (!isAppLockIn && !isLockInMMProduct && !isLockInProduct) {
      return checkout?.widgetscheckout?.sliders || [];
    }
    if (isAppLockIn && lockInApp) {
      return lockInApp?.widgets?.sliders || [];
    }
    if (startFromLockin && ((isLockInProduct && lockInHub) || lockInHub)) {
      return lockInHub?.widgets?.sliders && lockInHub?.widgets?.sliders.length > 0
        ? lockInHub?.widgets?.sliders || []
        : checkout?.widgetscheckout?.sliders || [];
    }
    if ((isLockInMMProduct && lockInMM) || (isAlternativeOffer && isLockInProduct && lockInMM)) {
      return lockInMM?.widgets?.sliders || [];
    }
    return checkout?.widgetscheckout?.sliders || [];
  };

  const getOrganizedWidgets = (): ICarouselCMS[] => {
    const sliders = getWidgets();
    if (product.isGlobalPromoActive) {
      if (globalpromo?.flags?.showVerticalCard === 'true')
        return pushWidgets(IWidgetType.IMAGE_TITLE_DESCRIPTION, sliders, globalpromo);
      else if (globalpromo?.flags?.showHorizontalCard === 'true')
        return insertWidget(1, sliders, {
          type: IWidgetType.SPLITTED_IMAGE_TEXT,
          title: '',
          elements: [
            {
              ...globalpromo.horizontalCard,
            },
          ],
        });
    }
    return sliders;
  };
  return (
    <>
      {isSuccessDynamicCart && <CartOfferProposal />}
      <TopShoppingCartBanner
        background={globalConfigCms?.globalconfig?.banner?.backgroundColor}
        afterLogoLabel={globalConfigCms?.globalconfig?.banner?.description}
        textColor="white"
        logo={globalConfigCms?.globalconfig?.banner?.image}
        isShown={showFwBanner}
        setIsShown={setShowFwBanner}
      />
      <WidgetWrapper padding={!isShowCheckout ? `${stickyOfferHeight || 90}` : '0'}>
        <ConsumerTopShoppingCart
          hub={startingHubTech || hub}
          titleOfferMap={techLabels?.bestOfferChoiceMap}
          editAddressLabel={techLabels?.editAddress}
          isSuccessDynamicCart={isSuccessDynamicCart}
          technologyShoppingCartInfo={technologyInfo?.shoppingCart}
        />
        {product?.shoppingCart?.shoppingCartDivider?.image &&
          product?.shoppingCart?.shoppingCartDivider?.text && (
            <Fade direction="up" triggerOnce>
              <ImageDivider
                image={product?.shoppingCart?.shoppingCartDivider?.image}
                alt={product?.shoppingCart?.shoppingCartDivider.text || ''}
              />
            </Fade>
          )}
      </WidgetWrapper>
      {!isShowCheckout && (
        <StickyOffer
          id="sticky-offer-summary"
          getContentHeight={setStickyOfferHeight}
          title={getFormattedPriceString(product.price, product.recurrence)}
          isLoading={IS_LOADING_CART}
          description={{
            openProductDetails: product?.buttonShow,
            closeProductDetails: product?.buttonHide,
          }}
          ctaActivation={{
            action: () => setIsShowCheckout(true),
            label: product?.shoppingCart?.buttonFooter?.buttonGoNext || 'Prosegui',
          }}
          showDetailLabel={product?.buttonShow || ''}
          hideDetailLabel={product?.buttonHide || ''}
          topLabel={product?.topLabelStickyCheckout || ''}
          content={
            <ProductDetail
              trackingOpt={{
                event: ['view'],
                event_label: 'offer details',
                opts: {
                  product_target_segment: 'consumer',
                  page_section: 'fixed offers',
                  page_subsection: 'checkout',
                },
                cartProduct: {
                  cart_product_id: `${product?.offerId}`,
                  cart_product_name: product?.slug,
                  cart_product_category: getProductCategory(product?.offerType || ''),
                  cart_product_price: product?.price && removeCurrency(product.price),
                  cart_product_quantity: '1',
                },
              }}
              details={{
                title: product.title,
                conditions: product.conditions,
                callMeNowHelp: product.callMeNowHelp,
                description: product.description,
                offerDetails: product.offerDetails,
                price: product.price,
                priceHtml: product.priceHtml,
                recurrence: product.recurrence,
                originalPrice: product.originalPrice,
              }}
              modalInfo={{
                title: supportModulesCms?.supportmodules?.needHelp?.title || '',
                ctaName: supportModulesCms?.supportmodules?.needHelp?.ctaSupportCall || '',
              }}
              address={
                getLocalAddress()?.displayedAddress
                  ? `<h5 data-cs-mask="">${
                      product?.shoppingCart?.addressLabel || ''
                    }<br/><b>${handleFirstCharacterOfSentence(
                      getLocalAddress()?.displayedAddress || '',
                    )}</b></h5>`
                  : ''
              }
              product={product}
            />
          }
        />
      )}
      {/* NEW CART VIEW IMPLEMENTATION DES-27721
        {!IS_LOADING_CART && (
        <WidgetWrapper padding={haveStickyOffer ? '5' : '0'}>
          <Widgets widgets={getOrganizedWidgets()} />
        </WidgetWrapper>
      )} */}
    </>
  );
};

export default ShoppingCartContent;

